import {CommonModule} from '@angular/common';
import {ToastMessageComponent} from 'libs/shared/ui/src/lib/components/toast-messages/toast-message/toast-message.component';
/* eslint-disable @nx/enforce-module-boundaries */
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {GuardsCheckEnd, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';

import {ToastMessage, ToastService} from 'libs/shared/ui/src/lib/service/toast/toast.service';

@Component({
    imports: [CommonModule, ToastMessageComponent],
    selector: 'truelearn-web-toast-messages',
    templateUrl: './toast-messages.component.html',
    styleUrls: ['./toast-messages.component.scss']
})
export class ToastMessagesComponent implements OnInit, OnDestroy {
    @Input() queueSize = 1;

    toastMessages: Array<ToastMessage & {hide: boolean}> = [];
    latestMessage: string;

    private unsubscriber = new Subject<void>();

    constructor(
        private toastService: ToastService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.toastService.toastMessage$
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((message) => this.showMessage(message));

        this.toastService.hideAllMessages$.pipe(takeUntil(this.unsubscriber)).subscribe(() => this.hideAll());

        this.router.events
            .pipe(
                takeUntil(this.unsubscriber),
                filter((x) => x instanceof GuardsCheckEnd && x.shouldActivate)
            )
            .subscribe(() => this.hideOnNavigation());
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }

    private showMessage(message: ToastMessage): void {
        const overflow = this.toastMessages.length + 1 - this.queueSize;
        if (overflow > 0) {
            this.toastMessages.slice(0, overflow).forEach((x) => (x.hide = true));
        }
        this.toastMessages.push({...message, hide: false});
        // push message to screen reader announcer
        if (typeof message?.message === 'string' && message?.message?.length > 0) {
            this.latestMessage = null;
            // have to allow it to clear to be picked up again
            setTimeout(() => {
                this.latestMessage = message.message as string;
            }, 10);
        }
    }

    removeMessage(index: number): void {
        if (this.toastMessages.length > 0 && index < this.toastMessages.length) {
            this.toastMessages.splice(index, 1);
        }
    }

    private hideOnNavigation(): void {
        this.toastMessages.filter((x) => !x.persistOnNavigation).forEach((x) => (x.hide = true));
    }

    private hideAll(): void {
        this.toastMessages.forEach((x) => (x.hide = true));
    }
}
